const state = {};

const mutations = {};

const actions = {
  lintEmail(context, email) {
    const lowerCaseEmail = email.toLowerCase();
    const lintedEmail = lowerCaseEmail.replace(/\s+/g, "");
    return lintedEmail;
  },
  isEmail(context, email) {
    const re = /\S+@\S+\.\S+/;
    const lintEmail = email.replace(/\s+/g, "");
    return re.test(lintEmail);
  }
};

const getters = {};

const formsModule = {
  state,
  mutations,
  actions,
  getters
};

export default formsModule;
